import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { Container as Color } from 'library/components/color/styles';
import { Header5 } from 'library/styles/text';
import { IconBase } from 'library/styles/icon';
import { ButtonBaseStyles } from 'library/styles/button';
import { TransitionConfig } from '../../../constants/styles-config';

// eslint-disable-next-line import/prefer-default-export
export const SelectedColorsContainer = styled.div`
  padding: 25px 40px 25px 50px;
  background-color: ${Colors.shade07};
  
  ${Color} {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  
  ${Header5} {
    margin-bottom: 17px;
  }
`;

export const Icon = styled(IconBase)`
`;

export const Button = styled.div`
  ${ButtonBaseStyles};
  //width: 210px;
  padding: 10px 18px 10px 6px;
  font-size: 15px;
  border: 1px solid ${Colors.violet};
  color: ${Colors.violet};
  transition: background-color ${TransitionConfig}, color ${TransitionConfig};
  border-radius: 0;
  border-right-width: 0;
  
  &:first-child {
    border-bottom-left-radius: 100px;
    border-top-left-radius: 100px;
  }

  &:last-child {
    border-bottom-right-radius: 100px;
    border-top-right-radius: 100px;
    border-right-width: 1px;
  }
  
  ${({ isActive }) => (isActive ? `
    color: ${Colors.shade08};
    background-color: ${Colors.violet};
  ` : 'background-color: #fff;')}

  ${({ isDisabled }) => isDisabled && `
    background-color: #fff;
    color: ${Colors.shade09};
    border-color: ${Colors.shade09};
    pointer-events: none;
    text-decoration: none;
    cursor: not-allowed;
  `};
`;

export const Container = styled.div`
  .slick-track {
    display: flex;
    margin: 20px 0;
    overflow-x: hidden;
  }

  .slick-list {
    overflow-x: hidden;
  }
`;

export const TabsNavigation = styled.div`
  display: flex;
  width: calc(100% - 50px);
  margin: 40px 25px 20px;
  background-color: #F8F9FA;
`;
